import { Toolbar, AppBar, Stack, IconButton, Typography, Box } from '@mui/material';
import { BarProps } from '../../../interfaces/interfaces';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { appStyleMode } from '../../../helpers/clientConfigs';
import { AppStyle } from '../../../helpers/appStyle';
import { useRouteNavigator } from '../../../routes/useRouteNavigator';

export function NavBar(props: BarProps) {
  const routeNavigator = useRouteNavigator();
  const {
    barTitle,
    open = () => {
      routeNavigator.goBack();
    },
    actions,
  } = props;

  const getContent = () => {
    if (appStyleMode === AppStyle.Mobile) {
      return getMobileContent();
    }

    return null;
  };

  const getMobileContent = () => {
    return (
      <Box>
        <AppBar
          sx={{ backgroundColor: 'appBar.top.background', color: 'appBar.top.color' }}
          position="fixed"
          elevation={0}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ paddingRight: '20px', height: '56px' }}
          >
            <IconButton sx={{ marginLeft: '20px' }} onClick={() => open()}>
              <ArrowBackIosIcon sx={{ position: 'absolute', color: 'white' }} />
            </IconButton>
            <Typography sx={{ marginLeft: 'auto', fontSize: '20px' }} variant="button" display="block">
              {barTitle}
            </Typography>
            {actions}
          </Stack>
        </AppBar>
        <Toolbar />
      </Box>
    );
  };

  return getContent();
}
